// extracted by mini-css-extract-plugin
module.exports = {"ldsGrid":"loadingAnim_ldsGrid__UmAqd","lds-grid":"loadingAnim_lds-grid__1HLCD"};